import { ApiInvoiceGroup, PostBatchFilters } from '@app/infrastructure/api/models';
import { PostBatchStatusTab } from './_models';

export class SetPostBatchListConfig {
  static readonly type = '[Post Batch] Set List Config';
  constructor(
    public config: {
      itemsPerPage?: number;
      searchText?: string | null;
      invoiceGroup?: ApiInvoiceGroup;
      filters?: PostBatchFilters | null;
      statusTab?: PostBatchStatusTab | null;
    },
  ) {}
}
